export function removeQueryString(url) {
  return /([^?]+)/.exec(url)[1];
}
